<div class="row" *ngIf="this.data">
  <div class="col-12 mb-2 mt-2 text-center">
    <h1 class="h3 mb-1">
      Sacrament Meeting<br />
      <sub>Saratoga Springs 9th Ward | Orem Utah 2nd Stake (Tongan)</sub>
    </h1>
    <small>
      {{ this.data.date | date }}, {{ this.data.startTime }} to
      {{ this.data.endTime }},
      <a [href]="this.data.address.link" target="_blank">{{
        this.data.address.reference
      }}</a>
    </small>
    <hr />
  </div>

  <div class="col-12 mb-4" *ngIf="this.data.preludeSpecial">
    <div class="d-flex justify-content-between">
      <span>Prelude:</span>
      <s9-person
        class="text-right"
        [person]="this.data.preludeSpecial"
      ></s9-person>
    </div>
  </div>

  <div class="col-12 mb-2">
    <div class="d-flex justify-content-between">
      <span>Presiding:</span>
      <s9-person class="text-right" [person]="this.data.presiding"></s9-person>
    </div>
  </div>

  <div class="col-12 mb-4">
    <div class="d-flex justify-content-between">
      <span>Conducting:</span>
      <s9-person class="text-right" [person]="this.data.conducting"></s9-person>
    </div>
  </div>

  <div class="col-12 mb-2">
    <div class="d-flex justify-content-between">
      <span>Chorister:</span>
      <s9-person class="text-right" [person]="this.data.chorister"></s9-person>
    </div>
  </div>

  <div class="col-12 mb-2">
    <div class="d-flex justify-content-between">
      <span>Organist:</span>
      <s9-person class="text-right" [person]="this.data.organist"></s9-person>
    </div>
  </div>

  <div class="col-12 mb-2">
    <div class="d-flex justify-content-between">
      <span>Opening Song:</span>
      <s9-hymn class="text-right" [hymn]="this.data.openingSong"></s9-hymn>
    </div>
  </div>

  <div class="col-12 mb-4">
    <div class="d-flex justify-content-between">
      <span>Invocation:</span>
      <s9-person class="text-right" [person]="this.data.invocation"></s9-person>
    </div>
  </div>

  <div class="col-12 mb-2">
    <div class="d-flex justify-content-between">
      <span>Ward Business:</span>
      <s9-person class="text-right" [person]="this.data.conducting"></s9-person>
    </div>
  </div>

  <div class="col-12 mb-4">
    <div class="d-flex justify-content-between">
      <span>Stake Business:</span>
      <s9-person
        class="text-right"
        [person]="this.data.stakeBusinessAssignment"
      ></s9-person>
    </div>
  </div>

  <div class="col-12 mb-4">
    <hr />
    <div class="d-flex justify-content-between">
      <span>Sacrament Song:</span>
      <s9-hymn class="text-right" [hymn]="this.data.openingSong"></s9-hymn>
    </div>
  </div>

  <div class="col-12 text-center">
    <strong>Administration of Sacrament</strong>
    <hr />
  </div>

  <div class="col-12 mb-4 text-center" *ngIf="this.data.testimonySunday">
    <strong>Fast Sunday: Bearing of Testimonies</strong>
    <hr />
  </div>

  <div class="col-12 mb-2" *ngIf="!this.data.testimonySunday">
    <div
      class="d-flex justify-content-between mb-2"
      *ngFor="let speaker of speakersBeforeRestHymn"
    >
      <span *ngIf="speaker.role === 'narrator'">Narrator:</span>
      <span *ngIf="speaker.role === 'musical'">Musical Number:</span>
      <span *ngIf="speaker.role === 'speaker'">Speaker:</span>
      <span *ngIf="speaker.role === 'testimony'">Testimony:</span>
      <s9-person class="text-right" [person]="speaker.person"></s9-person>
    </div>
  </div>

  <div
    class="col-12 mb-2"
    *ngIf="this.data.restSong && !this.data.testimonySunday"
  >
    <div class="d-flex justify-content-between">
      <span>Rest Song:</span>
      <s9-hymn class="text-right" [hymn]="this.data.restSong"></s9-hymn>
    </div>
  </div>

  <div class="col-12 mb-2" *ngIf="!this.data.testimonySunday">
    <div
      class="d-flex justify-content-between mb-2"
      *ngFor="let speaker of speakersAfterRestHymn"
    >
      <span *ngIf="speaker.role === 'narrator'">Narrator:</span>
      <span *ngIf="speaker.role === 'musical'">Musical Number:</span>
      <span *ngIf="speaker.role === 'speaker'">Speaker:</span>
      <span *ngIf="speaker.role === 'testimony'">Testimony:</span>
      <s9-person class="text-right" [person]="speaker.person"></s9-person>
    </div>
  </div>

  <div class="col-12 mb-2">
    <div class="d-flex justify-content-between">
      <span>Closing Song:</span>
      <s9-hymn class="text-right" [hymn]="this.data.closingSong"></s9-hymn>
    </div>
  </div>

  <div class="col-12 mb-2">
    <div class="d-flex justify-content-between">
      <span>Benediction:</span>
      <s9-person
        class="text-right"
        [person]="this.data.benediction"
      ></s9-person>
    </div>
  </div>

  <div class="col-12 mb-2 text-center">
    <hr />
    <figure class="text-center">
      <blockquote class="blockquote">
        <p>
          But be ye doers of the word, and not hearers only, deceiving your own
          selves.
        </p>
      </blockquote>
      <figcaption class="blockquote-footer">
        <cite title="Source Title">James 1:22</cite>
      </figcaption>
    </figure>
  </div>
</div>
